<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <el-button type="info" @click="clickreturnshang">返回</el-button>
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Spstatusname" label="审批状态" min-width="5%"></el-table-column>
          <el-table-column prop="Oldjigouname" label="旧机构名称" min-width="10%"></el-table-column>
          <el-table-column prop="Oldphone" label="旧提现手机" min-width="10%"></el-table-column>
          <el-table-column prop="Oldusername" label="旧提现姓名" min-width="10%"></el-table-column>
          <el-table-column prop="Newjigouname" label="新机构名称" min-width="10%"></el-table-column>
          <el-table-column prop="Newphone" label="新提现手机" min-width="10%"></el-table-column>
          <el-table-column prop="Newusername" label="新提现姓名" min-width="10%"></el-table-column>
          <el-table-column prop="Name1" label="经办人" min-width="5%"></el-table-column>
          <el-table-column prop="Name2" label="副总经理" min-width="5%"></el-table-column>
          <el-table-column prop="Name3" label="系统管理员" min-width="5%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Spstatus == 0 && SubRule_ShenPiJiGou_Delete" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Spstatus == 1 && SubRule_ShenPiJiGou_FuZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1(scope.row)">副总经理审核</el-button>
              <el-button v-if="scope.row.Spstatus == 2 && SubRule_ShenPiJiGou_Admin" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe2(scope.row)">系统管理员操作</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <el-dialog
          title="审批"
          :visible.sync="dialogVisible"
          width="20%">
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="ShenHeOK">同意</el-button>
            <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="申请变更" name="second" v-if="SubRule_ShenPiJiGou_Add">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">机构名称(必填)</span>
          </label>
          <el-input v-model="addForm.newjigouname"></el-input>
        </el-form-item>
        <el-form-item label="提现账号姓名" class="addAdminForm">
          <el-input v-model="addForm.newusername"></el-input>
        </el-form-item>
        <el-form-item label="提现账号手机" class="addAdminForm">
          <el-input v-model="addForm.newphone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyShenPiJiGouModify',
  data () {
    return {
      activeName: 'first',
      addForm: {
        newjigouname: '',
        newusername: '',
        newphone: ''
      },
      dataList: [],
      dialogVisible: false,
      apiShenPiJiGouModifySHUrl: '',
      spid: 0,
      modifyid: 0,
      SubRule_ShenPiJiGou_Add: false,
      SubRule_ShenPiJiGou_Delete: false,
      SubRule_ShenPiJiGou_FuZong: false,
      SubRule_ShenPiJiGou_Admin: false
    }
  },
  mounted () {
    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiJiGou_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiJiGou_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiJiGou_Delete', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiJiGou_Delete = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiJiGou_FuZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiJiGou_FuZong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiJiGou_Admin', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiJiGou_Admin = true
      }
    })
  },
  methods: {
    LoadData (row) {
      this.spid = row.Id
      this.addForm.newjigouname = row.Jigouname
      this.addForm.newusername = row.Username
      this.addForm.newphone = row.Phone
      this.apiGetShenPiJiGouModifyList()
    },
    clickadd () {
      this.apiAddShenPiJiGouModify()
    },
    clickreturnshang () {
      this.$emit('triggerFunc', '')
    },
    clickreturn () {
      this.activeName = 'first'
    },
    ShenHe1 (row) {
      this.dialogVisible = true
      this.apiShenPiJiGouModifySHUrl = Vue.prototype.global.Url_ShenPiJiGouModifySH1
      this.modifyid = row.Id
    },
    ShenHe2 (row) {
      this.dialogVisible = true
      this.apiShenPiJiGouModifySHUrl = Vue.prototype.global.Url_ShenPiJiGouModifySH2
      this.modifyid = row.Id
    },
    ShenHeOK () {
      this.dialogVisible = false
      this.apiShenPiJiGouModifySH(1)
    },
    ShenHeNO () {
      this.dialogVisible = false
      this.apiShenPiJiGouModifySH(-1)
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiJiGouModify(row.Id)
      })
    },
    apiGetShenPiJiGouModifyList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.spid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiJiGouModifyList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiJiGouModify: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.spid,
        newjigouname: that.addForm.newjigouname,
        newusername: that.addForm.newusername,
        newphone: that.addForm.newphone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiJiGouModify, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiJiGouModifyList()

            // 清空添加
            that.addForm.newjigouname = ''
            that.addForm.newphone = ''
            that.addForm.newusername = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiJiGouModify: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiJiGouModify, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiJiGouModifyList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiJiGouModifySH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.spid,
        id: that.modifyid,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiJiGouModifySHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiJiGouModifyList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}
.select1{
    width: 113px;
    margin-right: 15px;
}
/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
/deep/ .el-table .cell {
  white-space: pre-line;
}
</style>
